import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IOffer } from "../../utils/types/models";

export default createEntityReducer<IOffer>(Endpoint.Offers, Endpoint.OffersList);
